module.exports = __webpack_public_path__ + "img/classroom_sync.41c9589e.png";